import React, { useEffect, useState } from "react";
import "./css/style.css";
import { useDispatch, useSelector } from "react-redux";
import { checkOutConfirmation, getProfileData } from "../../apis/apisServies";
import { setVisitorProfile } from "../../Store/actions/profile/profileReducer";
import {
  profileData,
  visitorID,
} from "../../Store/actions/profile/profileSelector";
import { useNotification } from "../../NotificationProvider/NotificationProvider";
import { useNavigate } from "react-router-dom";
import { searchList } from "../../Store/actions/checkoutSearch/checkoutSearchSelector";
import { setUserDatails } from "../../Store/actions/checkoutSearch/CheckoutScreenReducer";
import useFilterArrayById from "../../../hooks/useFilterArrayById";
import {
  findDisplayName,
  formatNumberWithMask,
  isViewOrgFeatures,
  isView,
  findVesselNameById,
} from "../../../utils/commonFunctionsAndStatices";
import { selectFieldTable } from "../../Store/actions/FieldTableData/FieldTableSelector";
import { languageid } from "../../Store/actions/languageId/selectLanguageId";
import { selectToken } from "../../Store/actions/auth/authSelectors";
import { selecetPortID } from "../../Store/actions/portId/portSelect";
import { setOrganization } from "../../Store/actions/getorganization/organizationSelector";

export const ProfileScreen = () => {
  const { showSuccess, showError } = useNotification();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const visitor = useSelector(visitorID);
  const selecter = useSelector(searchList);
  const filteredData = useFilterArrayById(selecter, visitor);
  const [bagout, setBagout] = useState(0);
  const languageId = useSelector(languageid);
  const loginData = useSelector(selectToken);
  const portID = useSelector(selecetPortID);
  const fieldList = useSelector(selectFieldTable);
  const fieldData = fieldList
    ?.filter((field) => field.display_group === "Check-out")
    .sort((a, b) => a.sort_order - b.sort_order);
  const [selectedFieldValues, setSelectedFieldValues] = useState({});
  const [numberFieldValues, setNumberFieldValues] = useState({});
  const [booleanFieldValues, setBooleanFieldValues] = useState({});
  const [textFieldValues, setTextFieldValues] = useState({});
  const [selectedValue, setSelectedValue] = useState("Check-out");
  const [dateFieldValues, setDateFieldValues] = useState({});
  const [timeFieldValues, setTimeFieldValues] = useState({});
  const [underline, setUnderline] = useState(true);
  const [radioFieldValues, setRadioFieldValues] = useState({});
  const [loading, setIsloading] = useState(false);
  const organization = useSelector(setOrganization);

  const getFieldValue = (field) => {
    switch (field.field_type) {
      case "Select":
        return selectedFieldValues[field.organization_field_id] || "";
      case "Number":
        return numberFieldValues[field.organization_field_id] || "";
      case "Boolean":
        return booleanFieldValues[field.organization_field_id] || false;
      case "Radio":
        return radioFieldValues[field.organization_field_id] || "";
      case "Text":
        return (textFieldValues[field.organization_field_id] || "").trim();
      case "Date":
        return dateFieldValues[field.organization_field_id] || "";
      case "Time":
        return timeFieldValues[field.organization_field_id] || "";
      default:
        return null;
    }
  };

  const renderField = (field, index) => {
    let isFieldRequired = field.is_default;

    switch (field.field_type) {
      case "Select":
        return (
          <div key={index} className="width-input">
            <div className="dropdown">
              <button
                className="bg-white w-100 form-select text-start text-truncate"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ backgroundColor: "#E5E5E7" }}
              >
                {selectedValue === "Check-out"
                  ? selectedFieldValues[field.organization_field_id]
                    ? field.items.find(
                      (item) =>
                        item.detail_key ===
                        selectedFieldValues[field.organization_field_id]
                    )?.detail_value
                    : field.field_name
                  : field.field_name}
              </button>
              <ul className="dropdown-menu w-100 pb-2">
                {selectedValue === "Check-out" &&
                  field.items.map((item) => (
                    <li key={item.organization_field_details_id}>
                      <a
                        className="dropdown-item text-truncate"
                        onClick={() =>
                          handleSelectFieldChange(
                            { target: { value: item.detail_key } },
                            field.organization_field_id
                          )
                        }
                      >
                        {item.detail_value}
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        );

      case "Number":
        const numberFieldValue =
          numberFieldValues[field.organization_field_id] || "";
        const inputWidth = field?.field_length < 4 ? field?.field_length * 25 : field?.field_length * 16;
        return (
          <div key={index} className="col-7">
            <input
              type="text"
              className="form-control "
              id={field.organization_field_id}
              // placeholder={field?.field_name}
              maxLength={field?.field_length}
              autoComplete="off"
              onChange={(e) =>
                setNumberFieldValues((prevValues) => ({
                  ...prevValues,
                  [field.organization_field_id]: e.target.value.replace(
                    /[^0-9]/g,
                    ""
                  ),
                }))
              }
              value={numberFieldValue}
              required={isFieldRequired ? true : false}
              style={{ width: `${inputWidth}px`, backgroundColor: "#E5E5E7" }}
            />
          </div>
        );

      case "Boolean":
        const booleanFieldValue =
          booleanFieldValues[field.organization_field_id] || false;
        return (
          <div key={index} className=" form-check">
            <input
              type="checkbox"
              className="form-check-input border-dark "
              for="flexCheckChecked"
              id={field.organization_field_id}
              autoComplete="off"
              onChange={() =>
                setBooleanFieldValues((prevValues) => ({
                  ...prevValues,
                  [field.organization_field_id]:
                    !prevValues[field.organization_field_id],
                }))
              }
              checked={booleanFieldValue}
              required={isFieldRequired ? true : false}
            />
          </div>
        );
      case "Text":
        const textFieldValue =
          textFieldValues[field.organization_field_id] || "";
        return (
          <div key={index} className="col-12">
            <input
              type="text"
              className="form-control "
              style={{ backgroundColor: "#E5E5E7" }}
              maxLength={field?.field_length}
              id={field.organization_field_id}
              placeholder={field.field_name}
              autoComplete="off"
              onChange={(e) =>
                setTextFieldValues((prevValues) => ({
                  ...prevValues,
                  [field.organization_field_id]: e.target.value,
                }))
              }
              value={textFieldValue}
              required={isFieldRequired ? true : false}
            />
          </div>
        );

      case "Date":
        const dateFieldValue =
          dateFieldValues[field.organization_field_id] || "";
        return (
          <div key={index} className="date-time-width">
            <input
              type="date"
              className="form-control "
              style={{ backgroundColor: "#E5E5E7" }}
              id={field.organization_field_id}
              // placeholder={field.field_name}
              onChange={(e) =>
                setDateFieldValues((prevValues) => ({
                  ...prevValues,
                  [field.organization_field_id]: e.target.value,
                }))
              }
              value={dateFieldValue}
              required={isFieldRequired ? true : false}
            />
          </div>
        );

      case "Time":
        const timeFieldValue =
          timeFieldValues[field.organization_field_id] || "";
        return (
          <div key={index} className="date-time-width">
            <input
              type="time"
              className="form-control "
              style={{ backgroundColor: "#E5E5E7" }}
              id={field.organization_field_id}
              onChange={(e) =>
                setTimeFieldValues((prevValues) => ({
                  ...prevValues,
                  [field.organization_field_id]: e.target.value,
                }))
              }
              value={timeFieldValue}
              required={isFieldRequired ? true : false}
            />
          </div>
        );

      case "Radio":
        const radioFieldValue =
          radioFieldValues[field.organization_field_id] || "";
        return (
          <div key={index} className="col-12">
            {field.items.map((item, itemIndex) => (
              <div key={itemIndex} className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input"
                  id={`${field.organization_field_id}_${itemIndex}`}
                  name={field.organization_field_id}
                  value={item.detail_value}
                  checked={radioFieldValue === item.detail_value}
                  onChange={(e) =>
                    setRadioFieldValues((prevValues) => ({
                      ...prevValues,
                      [field.organization_field_id]: e.target.value,
                    }))
                  }
                  required={isFieldRequired ? true : false}
                />
                <label htmlFor={`${field.organization_field_id}_${itemIndex}`}>
                  {item.detail_value}
                </label>
              </div>
            ))}
          </div>
        );

      default:
        return null;
    }
  };
  const handleSelectFieldChange = (e, organizationFieldId) => {
    const { value } = e.target;
    setSelectedFieldValues((prevValues) => ({
      ...prevValues,
      [organizationFieldId]: value,
    }));
  };

  useEffect(() => {
    if (visitor) {
      if (visitor.includes("visitor")) {
        var data = JSON.parse(sessionStorage.getItem("visitor"));
        var visitor_obj = data[visitor];
        const profileDetails = {
          badge_number: visitor_obj.checkin.badgenumber,
          country: findCountryNameById(visitor_obj.checkin.CountryId),
          name:
            visitor_obj.checkin.FirstName + " " + visitor_obj.checkin.LastName,
          phone: visitor_obj.checkin.Phone,
          photo: "",
          visitor_type: findVisiterTypeById(visitor_obj.checkin.visitortypeid),
          checkin_fields: visitor_obj?.checkin?.items?.map(item => {
            return {
              fieldname: item?.key,
              fieldresult: item?.value
            }

          })
        };
        dispatch(setVisitorProfile(profileDetails));
        findImage();
      } else if (!navigator.onLine) {
        var data = JSON.parse(sessionStorage.getItem("persist:root"));
        var dataList = data && JSON.parse(data?.csoReport).csodata;
        const profileData = dataList?.find((item) => item.visitorid === visitor);
        const formetData = modifyObject(profileData);
        dispatch(setVisitorProfile(formetData));
      }
      else {
        async function fetchProfileData() {
          try {
            const response = await getProfileData(visitor);
            const profileDetails = response.data.body;
            dispatch(setVisitorProfile(profileDetails));
          } catch (error) {
            console.log(error, "Error profile page");
          }
        }
        if (navigator.onLine) {
          fetchProfileData();
        }
        //* fetch profile data api
      }
    }
  }, [visitor, dispatch]);

  function modifyObject(originalObject) {
    // Create a new object to store the modified data
    let modifiedObject = {};

    // Copy over the unchanged properties
    modifiedObject.badge_number = originalObject.Badge;
    modifiedObject.name = originalObject.Name;
    modifiedObject.CheckIn = originalObject.CheckIn;
    modifiedObject.CheckOut = originalObject.CheckOut;
    modifiedObject.visitor_type = findVisiterTypeById(originalObject.visitortypeid);

    // Map and modify the items array
    modifiedObject.checkin_fields = originalObject.items.map(item => {
      return {
        fieldname: item.field_name,
        fieldresult: item.field_result
      };
    });

    return modifiedObject;
  }

  function findCountryNameById(id) {
    var root = JSON.parse(sessionStorage.getItem("persist:root"));
    var countryList = JSON.parse(root.getCountryArray).getCountryArr;
    const foundItem = countryList.find((item) => item.country_id === id);
    return foundItem ? foundItem.country_name : null;
  }

  function findVisiterTypeById(id) {
    var root = JSON.parse(sessionStorage.getItem("persist:root"));
    var visitorList = JSON.parse(root.visitorType).visitorArr;
    const foundItem = visitorList.find((item) => item.visitortypeid === id);
    return foundItem ? foundItem.name : null;
  }

  const findImage = async () => {
    var data = JSON.parse(sessionStorage.getItem("visitor"));
    var data = data[visitor]["img"];
    document.getElementById("offline").src = data;
  };

  const data = useSelector(profileData);
  const items = [];

  const fieldIsValid = (field) => {
    switch (field.field_type) {
      case "Select":
        const selectedValue = selectedFieldValues[field.organization_field_id];
        // Check if the selected value is not undefined and not an empty string
        return (
          selectedValue !== undefined &&
          selectedValue !== "" &&
          selectedFieldValues.hasOwnProperty(field.organization_field_id)
        );
      case "Number":
        return (
          numberFieldValues[field.organization_field_id] !== "" &&
          !isNaN(numberFieldValues[field.organization_field_id])
        );
      case "Boolean":
        return booleanFieldValues[field.organization_field_id] !== undefined;
      case "Text":
        return (
          textFieldValues.hasOwnProperty(field.organization_field_id) &&
          textFieldValues[field.organization_field_id] !== ""
        );
      case "Date":
        return (
          dateFieldValues[field.organization_field_id] !== undefined &&
          dateFieldValues[field.organization_field_id] !== ""
        );
      case "Time":
        return (
          timeFieldValues[field.organization_field_id] !== undefined &&
          timeFieldValues[field.organization_field_id] !== ""
        );
      case "Radio":
        return radioFieldValues[field.organization_field_id] !== undefined;
      default:
        return false;
    }
  };

  const checkOut = async () => {
    const checkOutFields = fieldData.filter(
      (field) => field.display_group === "Check-out"
    );

    const missingRequiredField = checkOutFields.find((field) => {
      const isValid = fieldIsValid(field);
      return field.is_default && !isValid;
    });

    if (missingRequiredField) {
      let data = (
        "profileScreenDynamicValidation",
        "Kindly provide details to this"
      );
      let fieldData = data + " " + missingRequiredField.field_name;
      showError(fieldData);
      return;
    }
    if (Array.isArray(fieldData)) {
      fieldData.forEach((field, index) => {
        if (field.display_group === "Check-out") {
          const key = field.field_name;
          const value = getFieldValue(field);
          const item = {
            key,
            value,
          };

          items.push(item);
        }
      });
    } else {
      fieldData = [];
      console.error("fieldData is not an array or is undefined/null");
    }

    const finalObj = {
      visitorid: visitor,
      time: "",
      NumberofBagsOut: bagout,
      items: items,
      checkout_port: portID,
      text_message: {
        language_id: languageId,
        organization_id: loginData?.organization_id,
      },
    };
    setIsloading(true);
    try {
      if (navigator.onLine) {
        setIsloading(true);
        const response = await checkOutConfirmation(finalObj);
        const message = response?.data?.body?.message;
        showSuccess(message);
        if (response.data.statusCode === 200) {
          setTimeout(() => {
            navigate("/CheckoutScreen");
            dispatch(setUserDatails(filteredData));
          }, 2000);
          setIsloading(false);
        } else if (response.data.statusCode === 400) {
          showError(response?.data?.body?.message);
          setIsloading(false);
        }
      } else {
        var data = {
          visitorid: visitor,
          time: new Date().toISOString().toString(),
          NumberofBagsOut: bagout,
        };
        var checkout = JSON.parse(sessionStorage.getItem("checkout"))
          ? JSON.parse(sessionStorage.getItem("checkout"))
          : [];
        var isExist = false;

        checkout.map((item) => {
          for (const [key, _] of Object.entries(item)) {
            if (key === visitor) isExist = true;
          }
        });

        if (isExist === false) checkout.push({ [visitor]: data });

        sessionStorage.setItem("checkout", JSON.stringify(checkout));
        showSuccess("user Checkout Successfully");
        navigate("/CheckoutScreen");
        setIsloading(false);
      }
    } catch (error) {
      console.error("Error during checkout:", error);
      setIsloading(false);
    }
  };

  const cancelCheckout = () => {
    navigate("/CheckoutScreen");
  };

  var innerWidth = window.innerWidth;
  return (
    <div className="container">
      <div className="card ps-lg-3 py-lg-3 p-md-3 p-3 p-lg-0 col-lg-12 col-md-12 col-sm-10 element-mobile">
        <div className="d-lg-flex  justify-content-center align-items-center align-items-lg-start ">
          <div className={`${innerWidth < 850 ? 'd-flex justify-content-center align-items-center' : ''}`}>
            {
              isViewOrgFeatures("isTakePicture") && (
                <div className="col-lg-12 col-md-5 col-7 mb-md-2 ms-md-3" >
                  {navigator.onLine && (
                    <img
                      src={data?.photo}
                      className="img-thumbnail rounded d-block h-100 w-100"
                      alt="avatar_img"
                    />
                  )}
                  {!navigator.onLine && (
                    <img
                      id="offline"
                      className="img-thumbnail rounded d-block"
                      alt="offline image"
                    />
                  )}
                </div>
              )
            }
          </div>


          <div className={`${isViewOrgFeatures("isTakePicture") ? "col-lg-8 col-md-11 col-sm-12 gap-3 mx-md-auto mx-lg-5 mx-sm-0" : "col-lg-10 col-md-11 col-sm-12 gap-3 mx-md-auto mx-lg-5 mx-sm-0"}`}>
            <div className="profile-scroll">
              <div className="row px-2">
                <div className="col-md-6 col-sm-12 ">
                  <div className="rounded bg-light p-2  mt-2 mt-md-1 mt-lg-1 ">
                    <div className="d-flex align-items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="45"
                        height="45"
                        viewBox="0 0 45 45"
                        fill="none"
                      >
                        <path
                          d="M0.849609 6.11621C0.849609 2.8025 3.5359 0.116211 6.84961 0.116211H38.8496C42.1633 0.116211 44.8496 2.8025 44.8496 6.11621V38.1162C44.8496 41.4299 42.1633 44.1162 38.8496 44.1162H6.84961C3.5359 44.1162 0.849609 41.4299 0.849609 38.1162V6.11621Z"
                          fill="#0271BE"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M22.8496 13.1162C19.9501 13.1162 17.5996 15.4667 17.5996 18.3662C17.5996 21.2657 19.9501 23.6162 22.8496 23.6162C25.7491 23.6162 28.0996 21.2657 28.0996 18.3662C28.0996 15.4667 25.7491 13.1162 22.8496 13.1162ZM27.0713 24.261C28.905 22.9453 30.0996 20.7953 30.0996 18.3662C30.0996 14.3621 26.8537 11.1162 22.8496 11.1162C18.8455 11.1162 15.5996 14.3621 15.5996 18.3662C15.5996 20.7953 16.7942 22.9453 18.6279 24.261C17.3402 24.6725 16.171 25.2685 15.1785 26.0129C13.1795 27.5122 11.8496 29.6598 11.8496 32.1162C11.8496 32.6685 12.2973 33.1162 12.8496 33.1162C13.4019 33.1162 13.8496 32.6685 13.8496 32.1162C13.8496 30.4305 14.7583 28.8281 16.3785 27.6129C17.9991 26.3975 20.2836 25.6162 22.8496 25.6162C25.4156 25.6162 27.7002 26.3975 29.3207 27.6129C30.9409 28.8281 31.8496 30.4305 31.8496 32.1162C31.8496 32.6685 32.2973 33.1162 32.8496 33.1162C33.4019 33.1162 33.8496 32.6685 33.8496 32.1162C33.8496 29.6598 32.5197 27.5122 30.5207 26.0129C29.5282 25.2685 28.359 24.6725 27.0713 24.261Z"
                          fill="white"
                        />
                      </svg>
                      <div className="d-flex flex-column ms-2">
                        <label className="text-secondary">
                          {findDisplayName("profileScreenFirstNameHeading", "First Name")}
                        </label>
                        <strong className="text-dark font-weight-bold">
                          {data?.firstname}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-12 ">
                  <div className="rounded bg-light p-2  mt-2 mt-md-1 mt-lg-1 ">
                    <div className="d-flex align-items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="45"
                        height="45"
                        viewBox="0 0 45 45"
                        fill="none"
                      >
                        <path
                          d="M0.849609 6.11621C0.849609 2.8025 3.5359 0.116211 6.84961 0.116211H38.8496C42.1633 0.116211 44.8496 2.8025 44.8496 6.11621V38.1162C44.8496 41.4299 42.1633 44.1162 38.8496 44.1162H6.84961C3.5359 44.1162 0.849609 41.4299 0.849609 38.1162V6.11621Z"
                          fill="#0271BE"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M22.8496 13.1162C19.9501 13.1162 17.5996 15.4667 17.5996 18.3662C17.5996 21.2657 19.9501 23.6162 22.8496 23.6162C25.7491 23.6162 28.0996 21.2657 28.0996 18.3662C28.0996 15.4667 25.7491 13.1162 22.8496 13.1162ZM27.0713 24.261C28.905 22.9453 30.0996 20.7953 30.0996 18.3662C30.0996 14.3621 26.8537 11.1162 22.8496 11.1162C18.8455 11.1162 15.5996 14.3621 15.5996 18.3662C15.5996 20.7953 16.7942 22.9453 18.6279 24.261C17.3402 24.6725 16.171 25.2685 15.1785 26.0129C13.1795 27.5122 11.8496 29.6598 11.8496 32.1162C11.8496 32.6685 12.2973 33.1162 12.8496 33.1162C13.4019 33.1162 13.8496 32.6685 13.8496 32.1162C13.8496 30.4305 14.7583 28.8281 16.3785 27.6129C17.9991 26.3975 20.2836 25.6162 22.8496 25.6162C25.4156 25.6162 27.7002 26.3975 29.3207 27.6129C30.9409 28.8281 31.8496 30.4305 31.8496 32.1162C31.8496 32.6685 32.2973 33.1162 32.8496 33.1162C33.4019 33.1162 33.8496 32.6685 33.8496 32.1162C33.8496 29.6598 32.5197 27.5122 30.5207 26.0129C29.5282 25.2685 28.359 24.6725 27.0713 24.261Z"
                          fill="white"
                        />
                      </svg>
                      <div className="d-flex flex-column ms-2">
                        <label className="text-secondary">
                          {findDisplayName("profileScreenLastNameHeading", "Last Name")}
                        </label>
                        <strong className="text-dark font-weight-bold">
                          {data?.lastname}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div className="row px-2 mt-2">
                {
                  isViewOrgFeatures("isVisibleBatch") && (
                    <div className="col-md-6 col-sm-12">
                      <div className="rounded bg-light p-2  ">
                        <div className="d-flex align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="45"
                            height="45"
                            viewBox="0 0 45 45"
                            fill="none"
                          >
                            <path
                              d="M0.6604 6.11621C0.6604 2.8025 3.34669 0.116211 6.6604 0.116211H38.6604C41.9741 0.116211 44.6604 2.8025 44.6604 6.11621V38.1162C44.6604 41.4299 41.9741 44.1162 38.6604 44.1162H6.6604C3.34669 44.1162 0.6604 41.4299 0.6604 38.1162V6.11621Z"
                              fill="#0271BE"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12.1604 15.6162C12.1604 13.9594 13.5035 12.6162 15.1604 12.6162H31.1604C32.8173 12.6162 34.1604 13.9594 34.1604 15.6162V27.6162C34.1604 29.2731 32.8173 30.6162 31.1604 30.6162H23.1604C22.6081 30.6162 22.1604 30.1685 22.1604 29.6162C22.1604 29.0639 22.6081 28.6162 23.1604 28.6162H31.1604C31.7127 28.6162 32.1604 28.1685 32.1604 27.6162V15.6162C32.1604 15.0639 31.7127 14.6162 31.1604 14.6162H15.1604C14.6081 14.6162 14.1604 15.0639 14.1604 15.6162V19.6162C14.1604 20.1685 13.7127 20.6162 13.1604 20.6162C12.6081 20.6162 12.1604 20.1685 12.1604 19.6162V15.6162ZM21.1604 16.6162C21.7127 16.6162 22.1604 17.0639 22.1604 17.6162V21.6162C22.1604 22.1685 21.7127 22.6162 21.1604 22.6162C20.6081 22.6162 20.1604 22.1685 20.1604 21.6162V17.6162C20.1604 17.0639 20.6081 16.6162 21.1604 16.6162ZM25.1604 16.6162C25.7127 16.6162 26.1604 17.0639 26.1604 17.6162V25.6162C26.1604 26.1685 25.7127 26.6162 25.1604 26.6162C24.6081 26.6162 24.1604 26.1685 24.1604 25.6162V17.6162C24.1604 17.0639 24.6081 16.6162 25.1604 16.6162ZM29.1604 18.6162C29.7127 18.6162 30.1604 19.0639 30.1604 19.6162V25.6162C30.1604 26.1685 29.7127 26.6162 29.1604 26.6162C28.6081 26.6162 28.1604 26.1685 28.1604 25.6162V19.6162C28.1604 19.0639 28.6081 18.6162 29.1604 18.6162ZM16.1604 23.6162C15.6081 23.6162 15.1604 24.0639 15.1604 24.6162C15.1604 25.1685 15.6081 25.6162 16.1604 25.6162C16.7127 25.6162 17.1604 25.1685 17.1604 24.6162C17.1604 24.0639 16.7127 23.6162 16.1604 23.6162ZM18.6555 26.2824C18.9744 25.8058 19.1604 25.2327 19.1604 24.6162C19.1604 22.9594 17.8173 21.6162 16.1604 21.6162C14.5035 21.6162 13.1604 22.9594 13.1604 24.6162C13.1604 25.2327 13.3464 25.8058 13.6653 26.2824C12.1692 27.1453 11.1604 28.76 11.1604 30.6111C11.1604 31.1662 11.6104 31.6162 12.1655 31.6162H20.1553C20.7104 31.6162 21.1604 31.1662 21.1604 30.6111C21.1604 28.76 20.1516 27.1453 18.6555 26.2824ZM16.1604 27.6162C14.8541 27.6162 13.7416 28.452 13.3302 29.6162H18.9906C18.5792 28.452 17.4667 27.6162 16.1604 27.6162Z"
                              fill="white"
                            />
                          </svg>
                          <div className="d-flex flex-column ms-2">
                            <label className="text-secondary">
                              {findDisplayName(
                                "profileScreenBadgeNumberHeading",
                                "Badge Number"
                              )}
                            </label>
                            <strong className="text-dark font-weight-bold">
                              {formatNumberWithMask(data?.badge_number, organization.badge_number_mask)}
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }

                <div className=" col-md-6 col-sm-12">
                  <div className="rounded bg-light p-2 ">
                    <div className="d-flex align-items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="45"
                        height="45"
                        viewBox="0 0 45 45"
                        fill="none"
                      >
                        <path
                          d="M0.849609 6.11621C0.849609 2.8025 3.5359 0.116211 6.84961 0.116211H38.8496C42.1633 0.116211 44.8496 2.8025 44.8496 6.11621V38.1162C44.8496 41.4299 42.1633 44.1162 38.8496 44.1162H6.84961C3.5359 44.1162 0.849609 41.4299 0.849609 38.1162V6.11621Z"
                          fill="#0271BE"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M14.8918 14.4639C15.2114 12.0107 17.3093 10.1162 19.8496 10.1162H28.8496C32.1633 10.1162 34.8496 12.8025 34.8496 16.1162V25.1162C34.8496 27.6565 32.9552 29.7544 30.502 30.074C30.4215 30.3394 30.3212 30.5938 30.1956 30.8402C29.6204 31.9691 28.7025 32.887 27.5736 33.4622C26.8743 33.8185 26.1106 33.9716 25.215 34.0448C24.3405 34.1162 23.2564 34.1162 21.8934 34.1162H19.8058C18.4428 34.1162 17.3588 34.1162 16.4842 34.0448C15.5886 33.9716 14.8249 33.8185 14.1257 33.4622C12.9967 32.887 12.0788 31.9691 11.5036 30.8402C11.1473 30.1409 10.9942 29.3772 10.9211 28.4816C10.8496 27.607 10.8496 26.523 10.8496 25.16V23.0725C10.8496 21.7094 10.8496 20.6254 10.9211 19.7508C10.9942 18.8552 11.1473 18.0915 11.5036 17.3923C12.0788 16.2633 12.9967 15.3454 14.1257 14.7702C14.3721 14.6446 14.6264 14.5443 14.8918 14.4639ZM17.0072 14.1541C17.7818 14.1162 18.7024 14.1162 19.8059 14.1162H21.8934C23.2564 14.1162 24.3404 14.1162 25.215 14.1877C26.1106 14.2608 26.8743 14.4139 27.5736 14.7702C28.7025 15.3454 29.6204 16.2633 30.1956 17.3923C30.5519 18.0915 30.705 18.8552 30.7782 19.7508C30.8496 20.6254 30.8496 21.7094 30.8496 23.0724V25.16C30.8496 26.2634 30.8496 27.184 30.8117 27.9586C31.9967 27.5577 32.8496 26.4365 32.8496 25.1162V16.1162C32.8496 13.9071 31.0587 12.1162 28.8496 12.1162H19.8496C18.5293 12.1162 17.4082 12.9692 17.0072 14.1541ZM16.647 16.181C15.8751 16.2441 15.404 16.3635 15.0336 16.5522C14.281 16.9357 13.6691 17.5476 13.2856 18.3002C13.0969 18.6706 12.9775 19.1417 12.9144 19.9137C12.8504 20.6972 12.8496 21.6996 12.8496 23.1162V25.1162C12.8496 26.5328 12.8504 27.5352 12.9144 28.3188C12.9775 29.0907 13.0969 29.5619 13.2856 29.9322C13.6691 30.6848 14.281 31.2967 15.0336 31.6802C15.404 31.8689 15.8751 31.9883 16.647 32.0514C17.4306 32.1154 18.433 32.1162 19.8496 32.1162H21.8496C23.2662 32.1162 24.2686 32.1154 25.0522 32.0514C25.8241 31.9883 26.2953 31.8689 26.6656 31.6802C27.4182 31.2967 28.0301 30.6848 28.4136 29.9322C28.6023 29.5619 28.7217 29.0907 28.7848 28.3188C28.8488 27.5352 28.8496 26.5328 28.8496 25.1162V23.1162C28.8496 21.6996 28.8488 20.6972 28.7848 19.9137C28.7217 19.1417 28.6023 18.6706 28.4136 18.3002C28.0301 17.5476 27.4182 16.9357 26.6656 16.5522C26.2953 16.3635 25.8241 16.2441 25.0522 16.181C24.2686 16.117 23.2662 16.1162 21.8496 16.1162H19.8496C18.433 16.1162 17.4306 16.117 16.647 16.181ZM20.8824 21.1162C19.9294 21.1162 19.2323 21.845 19.2323 22.6531C19.2323 23.4612 19.9294 24.19 20.8824 24.19C21.8354 24.19 22.5326 23.4612 22.5326 22.6531C22.5326 21.845 21.8354 21.1162 20.8824 21.1162ZM17.2323 22.6531C17.2323 20.659 18.9081 19.1162 20.8824 19.1162C22.8567 19.1162 24.5326 20.659 24.5326 22.6531C24.5326 23.6023 24.1528 24.4493 23.5419 25.0763C24.2666 25.3848 24.9458 25.824 25.5411 26.3938C25.9401 26.7757 25.9539 27.4088 25.572 27.8077C25.1901 28.2067 24.5571 28.2205 24.1581 27.8386C22.3357 26.094 19.3636 26.094 17.5411 27.8386C17.1421 28.2205 16.5091 28.2067 16.1272 27.8077C15.7453 27.4088 15.7592 26.7757 16.1581 26.3938C16.7662 25.8118 17.4618 25.366 18.2039 25.0567C17.6041 24.4317 17.2323 23.5925 17.2323 22.6531Z"
                          fill="white"
                        />
                      </svg>
                      <div className="d-flex flex-column ms-2 ">
                        <label className="text-secondary">
                          {findDisplayName(
                            "profileScreenVisitorTypeHeading",
                            "Visitor Type"
                          )}
                        </label>
                        <strong className="text-dark font-weight-bold">
                          {data?.visitor_type}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div className="row p-2">

                <div className=" col-md-6 col-sm-12">
                  <div className="rounded bg-light p-2 ">
                    <div className="d-flex align-items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="45"
                        height="45"
                        viewBox="0 0 45 45"
                        fill="none"
                      >
                        <path
                          d="M0.849609 6.11621C0.849609 2.8025 3.5359 0.116211 6.84961 0.116211H38.8496C42.1633 0.116211 44.8496 2.8025 44.8496 6.11621V38.1162C44.8496 41.4299 42.1633 44.1162 38.8496 44.1162H6.84961C3.5359 44.1162 0.849609 41.4299 0.849609 38.1162V6.11621Z"
                          fill="#0271BE"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M19.8059 10.1162H25.8934C27.2564 10.1162 28.3404 10.1162 29.215 10.1877C30.1106 10.2608 30.8743 10.4139 31.5736 10.7702C32.7025 11.3454 33.6204 12.2633 34.1956 13.3923C34.5519 14.0915 34.705 14.8552 34.7782 15.7508C34.8496 16.6254 34.8496 17.7094 34.8496 19.0724V25.16C34.8496 26.523 34.8496 27.607 34.7782 28.4816C34.705 29.3772 34.5519 30.1409 34.1956 30.8402C33.6204 31.9691 32.7025 32.887 31.5736 33.4622C30.8743 33.8185 30.1106 33.9716 29.215 34.0448C28.3404 34.1162 27.2564 34.1162 25.8934 34.1162H19.8058C18.4428 34.1162 17.3588 34.1162 16.4842 34.0448C15.5886 33.9716 14.8249 33.8185 14.1257 33.4622C12.9967 32.887 12.0788 31.9691 11.5036 30.8402C11.1473 30.1409 10.9942 29.3772 10.9211 28.4816C10.8496 27.607 10.8496 26.523 10.8496 25.16V19.0725C10.8496 17.7094 10.8496 16.6254 10.9211 15.7508C10.9942 14.8552 11.1473 14.0915 11.5036 13.3923C12.0788 12.2633 12.9967 11.3454 14.1257 10.7702C14.8249 10.4139 15.5886 10.2608 16.4842 10.1877C17.3588 10.1162 18.4428 10.1162 19.8059 10.1162ZM16.6471 12.181C15.8751 12.2441 15.404 12.3635 15.0336 12.5522C14.281 12.9357 13.6691 13.5476 13.2856 14.3002C13.0969 14.6706 12.9775 15.1417 12.9144 15.9137C12.8504 16.6972 12.8496 17.6996 12.8496 19.1162V25.1162C12.8496 26.5328 12.8504 27.5352 12.9144 28.3188C12.9775 29.0907 13.0969 29.5619 13.2856 29.9322C13.6691 30.6848 14.281 31.2967 15.0336 31.6802C15.404 31.8689 15.8751 31.9883 16.6471 32.0514C17.4306 32.1154 18.433 32.1162 19.8496 32.1162H25.8496C27.2662 32.1162 28.2686 32.1154 29.0522 32.0514C29.8241 31.9883 30.2953 31.8689 30.6656 31.6802C31.4182 31.2967 32.0301 30.6848 32.4136 29.9322C32.6023 29.5619 32.7217 29.0907 32.7848 28.3188C32.8488 27.5352 32.8496 26.5328 32.8496 25.1162V19.1162C32.8496 17.6996 32.8488 16.6972 32.7848 15.9137C32.7217 15.1417 32.6023 14.6706 32.4136 14.3002C32.0301 13.5476 31.4182 12.9357 30.6656 12.5522C30.2953 12.3635 29.8241 12.2441 29.0522 12.181C28.2686 12.117 27.2662 12.1162 25.8496 12.1162H19.8496C18.433 12.1162 17.4306 12.117 16.6471 12.181ZM17.8496 16.1162C17.8496 15.5639 18.2973 15.1162 18.8496 15.1162H26.8496C27.4019 15.1162 27.8496 15.5639 27.8496 16.1162C27.8496 16.6685 27.4019 17.1162 26.8496 17.1162H23.8496V24.1162C23.8496 24.6685 23.4019 25.1162 22.8496 25.1162C22.2973 25.1162 21.8496 24.6685 21.8496 24.1162V17.1162H18.8496C18.2973 17.1162 17.8496 16.6685 17.8496 16.1162ZM17.8496 28.1162C17.8496 27.5639 18.2973 27.1162 18.8496 27.1162H26.8496C27.4019 27.1162 27.8496 27.5639 27.8496 28.1162C27.8496 28.6685 27.4019 29.1162 26.8496 29.1162H18.8496C18.2973 29.1162 17.8496 28.6685 17.8496 28.1162Z"
                          fill="white"
                        />
                      </svg>
                      <div className="d-flex flex-column ms-2 ">
                        <label className="text-secondary">
                          {findDisplayName(
                            "profileScreenVesselHeading",
                            "Vessel"
                          )}
                        </label>
                        <strong className="text-dark font-weight-bold">
                          {findVesselNameById(data?.Locationid)}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>

                {data &&
                  data.checkin_fields &&
                  data.checkin_fields.length > 0 &&
                  data.checkin_fields?.map((item, index) => (
                    <div
                      className={`col-md-6  mt-md-2}`}
                      key={index}
                    >
                      <div className="rounded bg-light p-2 mt-2 mt-md-2 mb-2 mt-md-0 mt-lg-0">
                        <div className="d-flex align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="45"
                            height="45"
                            viewBox="0 0 45 45"
                            fill="none"
                          >
                            <path
                              d="M0.849609 6.11621C0.849609 2.8025 3.5359 0.116211 6.84961 0.116211H38.8496C42.1633 0.116211 44.8496 2.8025 44.8496 6.11621V38.1162C44.8496 41.4299 42.1633 44.1162 38.8496 44.1162H6.84961C3.5359 44.1162 0.849609 41.4299 0.849609 38.1162V6.11621Z"
                              fill="#0271BE"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M19.8059 10.1162H25.8934C27.2564 10.1162 28.3404 10.1162 29.215 10.1877C30.1106 10.2608 30.8743 10.4139 31.5736 10.7702C32.7025 11.3454 33.6204 12.2633 34.1956 13.3923C34.5519 14.0915 34.705 14.8552 34.7782 15.7508C34.8496 16.6254 34.8496 17.7094 34.8496 19.0724V25.16C34.8496 26.523 34.8496 27.607 34.7782 28.4816C34.705 29.3772 34.5519 30.1409 34.1956 30.8402C33.6204 31.9691 32.7025 32.887 31.5736 33.4622C30.8743 33.8185 30.1106 33.9716 29.215 34.0448C28.3404 34.1162 27.2564 34.1162 25.8934 34.1162H19.8058C18.4428 34.1162 17.3588 34.1162 16.4842 34.0448C15.5886 33.9716 14.8249 33.8185 14.1257 33.4622C12.9967 32.887 12.0788 31.9691 11.5036 30.8402C11.1473 30.1409 10.9942 29.3772 10.9211 28.4816C10.8496 27.607 10.8496 26.523 10.8496 25.16V19.0725C10.8496 17.7094 10.8496 16.6254 10.9211 15.7508C10.9942 14.8552 11.1473 14.0915 11.5036 13.3923C12.0788 12.2633 12.9967 11.3454 14.1257 10.7702C14.8249 10.4139 15.5886 10.2608 16.4842 10.1877C17.3588 10.1162 18.4428 10.1162 19.8059 10.1162ZM16.6471 12.181C15.8751 12.2441 15.404 12.3635 15.0336 12.5522C14.281 12.9357 13.6691 13.5476 13.2856 14.3002C13.0969 14.6706 12.9775 15.1417 12.9144 15.9137C12.8504 16.6972 12.8496 17.6996 12.8496 19.1162V25.1162C12.8496 26.5328 12.8504 27.5352 12.9144 28.3188C12.9775 29.0907 13.0969 29.5619 13.2856 29.9322C13.6691 30.6848 14.281 31.2967 15.0336 31.6802C15.404 31.8689 15.8751 31.9883 16.6471 32.0514C17.4306 32.1154 18.433 32.1162 19.8496 32.1162H25.8496C27.2662 32.1162 28.2686 32.1154 29.0522 32.0514C29.8241 31.9883 30.2953 31.8689 30.6656 31.6802C31.4182 31.2967 32.0301 30.6848 32.4136 29.9322C32.6023 29.5619 32.7217 29.0907 32.7848 28.3188C32.8488 27.5352 32.8496 26.5328 32.8496 25.1162V19.1162C32.8496 17.6996 32.8488 16.6972 32.7848 15.9137C32.7217 15.1417 32.6023 14.6706 32.4136 14.3002C32.0301 13.5476 31.4182 12.9357 30.6656 12.5522C30.2953 12.3635 29.8241 12.2441 29.0522 12.181C28.2686 12.117 27.2662 12.1162 25.8496 12.1162H19.8496C18.433 12.1162 17.4306 12.117 16.6471 12.181ZM17.8496 16.1162C17.8496 15.5639 18.2973 15.1162 18.8496 15.1162H26.8496C27.4019 15.1162 27.8496 15.5639 27.8496 16.1162C27.8496 16.6685 27.4019 17.1162 26.8496 17.1162H23.8496V24.1162C23.8496 24.6685 23.4019 25.1162 22.8496 25.1162C22.2973 25.1162 21.8496 24.6685 21.8496 24.1162V17.1162H18.8496C18.2973 17.1162 17.8496 16.6685 17.8496 16.1162ZM17.8496 28.1162C17.8496 27.5639 18.2973 27.1162 18.8496 27.1162H26.8496C27.4019 27.1162 27.8496 27.5639 27.8496 28.1162C27.8496 28.6685 27.4019 29.1162 26.8496 29.1162H18.8496C18.2973 29.1162 17.8496 28.6685 17.8496 28.1162Z"
                              fill="white"
                            />
                          </svg>
                          <div className="d-flex flex-column ms-2">
                            <label className="text-secondary d-flex justify-content-start">
                              {item.fieldname}
                            </label>
                            <strong className="">
                              {item?.fieldresult === "true"
                                ? "Yes"
                                : item.fieldresult === "false"
                                  ? "No"
                                  : item.fieldresult === ""
                                    ? "None"
                                    : item.fieldresult?.charAt(0).toUpperCase() +
                                    item.fieldresult.slice(1)}
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                <hr className="text-white mt-0 mb-0 ms-2 me-2 opacity-75" />
                {fieldData.map((field, index) => (
                  <div className="col-md-6 mt-sm-1">
                    <div className="rounded bg-light p-2 mt-2 mb-2 mt-md-0 mt-lg-0 ">
                      <div className="d-flex align-items-center">
                        {field?.field_type === "Number" && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="45"
                            height="45"
                            viewBox="0 0 45 45"
                            fill="none"
                          >
                            <rect
                              x="0.849609"
                              y="0.116211"
                              width="44"
                              height="44"
                              rx="6"
                              fill="#0271BE"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M13.4177 10.1162C13.4283 10.1162 13.439 10.1162 13.4496 10.1162H16.2496C16.2603 10.1162 16.2709 10.1162 16.2815 10.1162C16.5339 10.1162 16.7797 10.1162 16.9878 10.1332C17.2164 10.1518 17.4862 10.1959 17.7576 10.3342C18.1339 10.5259 18.4399 10.8319 18.6316 11.2082C18.7699 11.4797 18.814 11.7494 18.8327 11.978C18.8497 12.1861 18.8496 12.4319 18.8496 12.6843C18.8496 12.6949 18.8496 12.7056 18.8496 12.7162V13.1162L26.8496 13.1162L26.8496 12.6843C26.8496 12.4319 26.8496 12.1861 26.8666 11.978C26.8852 11.7494 26.9293 11.4797 27.0676 11.2082C27.2593 10.8319 27.5653 10.526 27.9416 10.3342C28.2131 10.1959 28.4828 10.1518 28.7114 10.1332C28.9195 10.1162 29.1653 10.1162 29.4177 10.1162H32.2815C32.5339 10.1162 32.7797 10.1162 32.9878 10.1332C33.2164 10.1518 33.4862 10.1959 33.7576 10.3342C34.1339 10.526 34.4399 10.8319 34.6316 11.2082C34.7699 11.4797 34.814 11.7494 34.8327 11.978C34.8497 12.1861 34.8496 12.4319 34.8496 12.6843V15.5481C34.8496 15.8005 34.8497 16.0463 34.8327 16.2544C34.814 16.483 34.7699 16.7528 34.6316 17.0242C34.4399 17.4005 34.1339 17.7065 33.7576 17.8982C33.4862 18.0365 33.2164 18.0806 32.9878 18.0993C32.7797 18.1163 32.5339 18.1162 32.2815 18.1162L31.8496 18.1162V26.1162L32.2815 26.1162C32.5339 26.1162 32.7797 26.1162 32.9878 26.1332C33.2164 26.1518 33.4862 26.1959 33.7576 26.3342C34.1339 26.526 34.4399 26.8319 34.6316 27.2082C34.7699 27.4797 34.814 27.7494 34.8327 27.978C34.8497 28.1861 34.8496 28.4319 34.8496 28.6843V31.5481C34.8496 31.8005 34.8497 32.0463 34.8327 32.2544C34.814 32.483 34.7699 32.7528 34.6316 33.0242C34.4399 33.4005 34.1339 33.7065 33.7576 33.8982C33.4862 34.0365 33.2164 34.0806 32.9878 34.0993C32.7797 34.1163 32.5339 34.1162 32.2815 34.1162H29.4177C29.1653 34.1162 28.9195 34.1163 28.7114 34.0993C28.4828 34.0806 28.2131 34.0365 27.9416 33.8982C27.5653 33.7065 27.2593 33.4005 27.0676 33.0242C26.9293 32.7528 26.8852 32.483 26.8666 32.2544C26.8496 32.0463 26.8496 31.8005 26.8496 31.5481L26.8496 31.1162H18.8496L18.8496 31.5481C18.8496 31.8005 18.8497 32.0463 18.8327 32.2544C18.814 32.483 18.7699 32.7528 18.6316 33.0242C18.4399 33.4005 18.1339 33.7065 17.7576 33.8982C17.4862 34.0365 17.2164 34.0806 16.9878 34.0993C16.7797 34.1163 16.5339 34.1162 16.2815 34.1162H13.4177C13.1653 34.1162 12.9195 34.1163 12.7114 34.0993C12.4828 34.0806 12.2131 34.0365 11.9416 33.8982C11.5653 33.7065 11.2593 33.4005 11.0676 33.0242C10.9293 32.7528 10.8852 32.483 10.8666 32.2544C10.8496 32.0463 10.8496 31.8005 10.8496 31.5481V28.6843C10.8496 28.4319 10.8496 28.1861 10.8666 27.978C10.8852 27.7494 10.9293 27.4797 11.0676 27.2082C11.2593 26.8319 11.5653 26.5259 11.9416 26.3342C12.2131 26.1959 12.4828 26.1518 12.7114 26.1332C12.9195 26.1162 13.1653 26.1162 13.4177 26.1162L13.8496 26.1162V18.1162H13.4496C13.439 18.1162 13.4283 18.1162 13.4177 18.1162C13.1653 18.1162 12.9195 18.1163 12.7114 18.0993C12.4828 18.0806 12.2131 18.0365 11.9416 17.8982C11.5653 17.7065 11.2593 17.4005 11.0676 17.0242C10.9293 16.7528 10.8852 16.483 10.8666 16.2544C10.8496 16.0463 10.8496 15.8005 10.8496 15.5481C10.8496 15.5375 10.8496 15.5269 10.8496 15.5162V12.7162C10.8496 12.7056 10.8496 12.6949 10.8496 12.6843C10.8496 12.4319 10.8496 12.1861 10.8666 11.978C10.8852 11.7494 10.9293 11.4797 11.0676 11.2082C11.2593 10.8319 11.5653 10.5259 11.9416 10.3342C12.2131 10.1959 12.4828 10.1518 12.7114 10.1332C12.9195 10.1162 13.1653 10.1162 13.4177 10.1162ZM15.8496 18.1162V26.1162L16.2815 26.1162C16.5339 26.1162 16.7797 26.1162 16.9878 26.1332C17.2164 26.1518 17.4862 26.1959 17.7576 26.3342C18.1339 26.5259 18.4399 26.8319 18.6316 27.2082C18.7699 27.4797 18.814 27.7494 18.8327 27.978C18.8497 28.1861 18.8496 28.4319 18.8496 28.6843L18.8496 29.1162H26.8496L26.8496 28.6843C26.8496 28.4319 26.8496 28.1861 26.8666 27.978C26.8852 27.7494 26.9293 27.4797 27.0676 27.2082C27.2593 26.8319 27.5653 26.526 27.9416 26.3342C28.2131 26.1959 28.4828 26.1518 28.7114 26.1332C28.9195 26.1162 29.1653 26.1162 29.4177 26.1162L29.8496 26.1162V18.1162L29.4177 18.1162C29.1653 18.1162 28.9195 18.1163 28.7114 18.0993C28.4828 18.0806 28.2131 18.0365 27.9416 17.8982C27.5653 17.7065 27.2593 17.4005 27.0676 17.0242C26.9293 16.7528 26.8852 16.483 26.8666 16.2544C26.8496 16.0463 26.8496 15.8005 26.8496 15.5481L26.8496 15.1162L18.8496 15.1162V15.5162C18.8496 15.5269 18.8496 15.5375 18.8496 15.5481C18.8496 15.8005 18.8497 16.0463 18.8327 16.2544C18.814 16.483 18.7699 16.7528 18.6316 17.0242C18.4399 17.4005 18.1339 17.7065 17.7576 17.8982C17.4862 18.0365 17.2164 18.0806 16.9878 18.0993C16.7797 18.1163 16.5339 18.1162 16.2815 18.1162C16.2709 18.1162 16.2603 18.1162 16.2496 18.1162H15.8496ZM12.8611 12.1277C12.8607 12.1318 12.8603 12.1362 12.8599 12.1408C12.8504 12.2574 12.8496 12.4197 12.8496 12.7162V15.5162C12.8496 15.8127 12.8504 15.975 12.8599 16.0916C12.8603 16.0962 12.8607 16.1006 12.8611 16.1048C12.8652 16.1052 12.8696 16.1055 12.8742 16.1059C12.9908 16.1154 13.1531 16.1162 13.4496 16.1162H16.2496C16.5461 16.1162 16.7084 16.1154 16.825 16.1059C16.8296 16.1055 16.834 16.1052 16.8382 16.1048C16.8385 16.1006 16.8389 16.0962 16.8393 16.0916C16.8488 15.975 16.8496 15.8127 16.8496 15.5162V12.7162C16.8496 12.4197 16.8488 12.2574 16.8393 12.1409C16.8389 12.1362 16.8385 12.1318 16.8382 12.1277C16.834 12.1273 16.8296 12.1269 16.825 12.1265C16.7084 12.117 16.5461 12.1162 16.2496 12.1162H13.4496C13.1531 12.1162 12.9908 12.117 12.8742 12.1265C12.8696 12.1269 12.8652 12.1273 12.8611 12.1277ZM28.8611 12.1277C28.8607 12.1318 28.8603 12.1362 28.8599 12.1409C28.8504 12.2574 28.8496 12.4197 28.8496 12.7162V15.5162C28.8496 15.8127 28.8504 15.975 28.8599 16.0916C28.8603 16.0962 28.8607 16.1006 28.8611 16.1048C28.8652 16.1051 28.8696 16.1055 28.8742 16.1059C28.9908 16.1154 29.1531 16.1162 29.4496 16.1162H32.2496C32.5461 16.1162 32.7084 16.1154 32.825 16.1059C32.8296 16.1055 32.834 16.1051 32.8382 16.1048C32.8386 16.1006 32.8389 16.0962 32.8393 16.0916C32.8488 15.975 32.8496 15.8127 32.8496 15.5162V12.7162C32.8496 12.4197 32.8488 12.2574 32.8393 12.1409C32.8389 12.1362 32.8385 12.1318 32.8382 12.1277C32.834 12.1273 32.8296 12.1269 32.825 12.1265C32.7084 12.117 32.5461 12.1162 32.2496 12.1162H29.4496C29.1531 12.1162 28.9908 12.117 28.8742 12.1265C28.8696 12.1269 28.8652 12.1273 28.8611 12.1277ZM18.8496 20.1162C18.8496 19.5639 19.2973 19.1162 19.8496 19.1162H25.8496C26.4019 19.1162 26.8496 19.5639 26.8496 20.1162C26.8496 20.6685 26.4019 21.1162 25.8496 21.1162H23.8496V26.1162C23.8496 26.6685 23.4019 27.1162 22.8496 27.1162C22.2973 27.1162 21.8496 26.6685 21.8496 26.1162V21.1162H19.8496C19.2973 21.1162 18.8496 20.6685 18.8496 20.1162ZM12.8611 28.1277C12.8607 28.1318 12.8603 28.1362 12.8599 28.1409C12.8504 28.2574 12.8496 28.4197 12.8496 28.7162V31.5162C12.8496 31.8127 12.8504 31.975 12.8599 32.0916C12.8603 32.0962 12.8607 32.1006 12.8611 32.1048C12.8652 32.1051 12.8696 32.1055 12.8742 32.1059C12.9908 32.1154 13.1531 32.1162 13.4496 32.1162H16.2496C16.5461 32.1162 16.7084 32.1154 16.825 32.1059C16.8296 32.1055 16.834 32.1051 16.8382 32.1048C16.8386 32.1006 16.8389 32.0962 16.8393 32.0916C16.8488 31.975 16.8496 31.8127 16.8496 31.5162V28.7162C16.8496 28.4197 16.8488 28.2574 16.8393 28.1409C16.8389 28.1362 16.8385 28.1318 16.8382 28.1277C16.834 28.1273 16.8296 28.1269 16.825 28.1265C16.7084 28.117 16.5461 28.1162 16.2496 28.1162H13.4496C13.1531 28.1162 12.9908 28.117 12.8742 28.1265C12.8696 28.1269 12.8652 28.1273 12.8611 28.1277ZM28.8611 28.1277C28.8607 28.1318 28.8603 28.1362 28.8599 28.1409C28.8504 28.2574 28.8496 28.4197 28.8496 28.7162V31.5162C28.8496 31.8127 28.8504 31.975 28.8599 32.0916C28.8603 32.0962 28.8607 32.1006 28.8611 32.1048C28.8652 32.1051 28.8696 32.1055 28.8742 32.1059C28.9908 32.1154 29.1531 32.1162 29.4496 32.1162H32.2496C32.5461 32.1162 32.7084 32.1154 32.825 32.1059C32.8296 32.1055 32.834 32.1051 32.8382 32.1048C32.8386 32.1006 32.8389 32.0962 32.8393 32.0916C32.8488 31.975 32.8496 31.8127 32.8496 31.5162V28.7162C32.8496 28.4197 32.8488 28.2574 32.8393 28.1409C32.8389 28.1362 32.8385 28.1318 32.8382 28.1277C32.834 28.1273 32.8296 28.1269 32.825 28.1265C32.7084 28.117 32.5461 28.1162 32.2496 28.1162H29.4496C29.1531 28.1162 28.9908 28.117 28.8742 28.1265C28.8696 28.1269 28.8652 28.1273 28.8611 28.1277Z"
                              fill="white"
                            />
                          </svg>
                        )}
                        {field?.field_type === "Text" && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="45"
                            height="45"
                            viewBox="0 0 45 45"
                            fill="none"
                          >
                            <path
                              d="M0.849609 6.11621C0.849609 2.8025 3.5359 0.116211 6.84961 0.116211H38.8496C42.1633 0.116211 44.8496 2.8025 44.8496 6.11621V38.1162C44.8496 41.4299 42.1633 44.1162 38.8496 44.1162H6.84961C3.5359 44.1162 0.849609 41.4299 0.849609 38.1162V6.11621Z"
                              fill="#0271BE"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M19.8059 10.1162H25.8934C27.2564 10.1162 28.3404 10.1162 29.215 10.1877C30.1106 10.2608 30.8743 10.4139 31.5736 10.7702C32.7025 11.3454 33.6204 12.2633 34.1956 13.3923C34.5519 14.0915 34.705 14.8552 34.7782 15.7508C34.8496 16.6254 34.8496 17.7094 34.8496 19.0724V25.16C34.8496 26.523 34.8496 27.607 34.7782 28.4816C34.705 29.3772 34.5519 30.1409 34.1956 30.8402C33.6204 31.9691 32.7025 32.887 31.5736 33.4622C30.8743 33.8185 30.1106 33.9716 29.215 34.0448C28.3404 34.1162 27.2564 34.1162 25.8934 34.1162H19.8058C18.4428 34.1162 17.3588 34.1162 16.4842 34.0448C15.5886 33.9716 14.8249 33.8185 14.1257 33.4622C12.9967 32.887 12.0788 31.9691 11.5036 30.8402C11.1473 30.1409 10.9942 29.3772 10.9211 28.4816C10.8496 27.607 10.8496 26.523 10.8496 25.16V19.0725C10.8496 17.7094 10.8496 16.6254 10.9211 15.7508C10.9942 14.8552 11.1473 14.0915 11.5036 13.3923C12.0788 12.2633 12.9967 11.3454 14.1257 10.7702C14.8249 10.4139 15.5886 10.2608 16.4842 10.1877C17.3588 10.1162 18.4428 10.1162 19.8059 10.1162ZM16.6471 12.181C15.8751 12.2441 15.404 12.3635 15.0336 12.5522C14.281 12.9357 13.6691 13.5476 13.2856 14.3002C13.0969 14.6706 12.9775 15.1417 12.9144 15.9137C12.8504 16.6972 12.8496 17.6996 12.8496 19.1162V25.1162C12.8496 26.5328 12.8504 27.5352 12.9144 28.3188C12.9775 29.0907 13.0969 29.5619 13.2856 29.9322C13.6691 30.6848 14.281 31.2967 15.0336 31.6802C15.404 31.8689 15.8751 31.9883 16.6471 32.0514C17.4306 32.1154 18.433 32.1162 19.8496 32.1162H25.8496C27.2662 32.1162 28.2686 32.1154 29.0522 32.0514C29.8241 31.9883 30.2953 31.8689 30.6656 31.6802C31.4182 31.2967 32.0301 30.6848 32.4136 29.9322C32.6023 29.5619 32.7217 29.0907 32.7848 28.3188C32.8488 27.5352 32.8496 26.5328 32.8496 25.1162V19.1162C32.8496 17.6996 32.8488 16.6972 32.7848 15.9137C32.7217 15.1417 32.6023 14.6706 32.4136 14.3002C32.0301 13.5476 31.4182 12.9357 30.6656 12.5522C30.2953 12.3635 29.8241 12.2441 29.0522 12.181C28.2686 12.117 27.2662 12.1162 25.8496 12.1162H19.8496C18.433 12.1162 17.4306 12.117 16.6471 12.181ZM17.8496 16.1162C17.8496 15.5639 18.2973 15.1162 18.8496 15.1162H26.8496C27.4019 15.1162 27.8496 15.5639 27.8496 16.1162C27.8496 16.6685 27.4019 17.1162 26.8496 17.1162H23.8496V24.1162C23.8496 24.6685 23.4019 25.1162 22.8496 25.1162C22.2973 25.1162 21.8496 24.6685 21.8496 24.1162V17.1162H18.8496C18.2973 17.1162 17.8496 16.6685 17.8496 16.1162ZM17.8496 28.1162C17.8496 27.5639 18.2973 27.1162 18.8496 27.1162H26.8496C27.4019 27.1162 27.8496 27.5639 27.8496 28.1162C27.8496 28.6685 27.4019 29.1162 26.8496 29.1162H18.8496C18.2973 29.1162 17.8496 28.6685 17.8496 28.1162Z"
                              fill="white"
                            />
                          </svg>
                        )}

                        {field?.field_type === "Boolean" && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="44"
                            height="44"
                            viewBox="0 0 44 44"
                            fill="none"
                          >
                            <rect
                              width="44"
                              height="44"
                              rx="6"
                              fill="#0271BE"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M18.9562 10H25.0438C26.4068 9.99999 27.4908 9.99999 28.3654 10.0714C29.261 10.1446 30.0247 10.2977 30.7239 10.654C31.8529 11.2292 32.7708 12.1471 33.346 13.2761C33.7023 13.9753 33.8554 14.739 33.9286 15.6346C34 16.5092 34 17.5932 34 18.9562V25.0438C34 26.4068 34 27.4908 33.9286 28.3654C33.8554 29.261 33.7023 30.0247 33.346 30.7239C32.7708 31.8529 31.8529 32.7708 30.7239 33.346C30.0247 33.7023 29.261 33.8554 28.3654 33.9286C27.4908 34 26.4068 34 25.0438 34H18.9562C17.5932 34 16.5092 34 15.6346 33.9286C14.739 33.8554 13.9753 33.7023 13.2761 33.346C12.1471 32.7708 11.2292 31.8529 10.654 30.7239C10.2977 30.0247 10.1446 29.261 10.0714 28.3654C9.99999 27.4908 9.99999 26.4068 10 25.0438V18.9562C9.99999 17.5932 9.99999 16.5092 10.0714 15.6346C10.1446 14.739 10.2977 13.9753 10.654 13.2761C11.2292 12.1471 12.1471 11.2292 13.2761 10.654C13.9753 10.2977 14.739 10.1446 15.6346 10.0714C16.5092 9.99999 17.5932 9.99999 18.9562 10ZM15.7974 12.0648C15.0255 12.1279 14.5543 12.2473 14.184 12.436C13.4314 12.8195 12.8195 13.4314 12.436 14.184C12.2473 14.5543 12.1279 15.0255 12.0648 15.7974C12.0008 16.581 12 17.5834 12 19V25C12 26.4166 12.0008 27.419 12.0648 28.2026C12.1279 28.9745 12.2473 29.4457 12.436 29.816C12.8195 30.5686 13.4314 31.1805 14.184 31.564C14.5543 31.7527 15.0255 31.8721 15.7974 31.9352C16.581 31.9992 17.5834 32 19 32H25C26.4166 32 27.419 31.9992 28.2026 31.9352C28.9745 31.8721 29.4457 31.7527 29.816 31.564C30.5686 31.1805 31.1805 30.5686 31.564 29.816C31.7527 29.4457 31.8721 28.9745 31.9352 28.2026C31.9992 27.419 32 26.4166 32 25V19C32 17.5834 31.9992 16.581 31.9352 15.7974C31.8721 15.0255 31.7527 14.5543 31.564 14.184C31.1805 13.4314 30.5686 12.8195 29.816 12.436C29.4457 12.2473 28.9745 12.1279 28.2026 12.0648C27.419 12.0008 26.4166 12 25 12H19C17.5834 12 16.581 12.0008 15.7974 12.0648ZM18.1615 14H25.8385C26.3657 14 26.8205 14 27.195 14.0306C27.5904 14.0629 27.9836 14.1342 28.362 14.327C28.9265 14.6146 29.3854 15.0735 29.673 15.638C29.8658 16.0164 29.9371 16.4096 29.9694 16.805C30 17.1795 30 17.6343 30 18.1614V25.8386C30 26.3657 30 26.8205 29.9694 27.195C29.9371 27.5904 29.8658 27.9836 29.673 28.362C29.3854 28.9265 28.9265 29.3854 28.362 29.673C27.9836 29.8658 27.5904 29.9371 27.195 29.9694C26.8205 30 26.3657 30 25.8386 30H18.1614C17.6343 30 17.1795 30 16.805 29.9694C16.4096 29.9371 16.0164 29.8658 15.638 29.673C15.0735 29.3854 14.6146 28.9265 14.327 28.362C14.1342 27.9836 14.0629 27.5904 14.0306 27.195C14 26.8205 14 26.3657 14 25.8385V18.1615C14 17.6343 14 17.1795 14.0306 16.805C14.0629 16.4096 14.1342 16.0164 14.327 15.638C14.6146 15.0735 15.0735 14.6146 15.638 14.327C16.0164 14.1342 16.4096 14.0629 16.805 14.0306C17.1795 14 17.6343 14 18.1615 14ZM16.9678 16.0239C16.6962 16.0461 16.5955 16.0838 16.546 16.109C16.3578 16.2049 16.2049 16.3578 16.109 16.546C16.0838 16.5955 16.0461 16.6962 16.0239 16.9678C16.0008 17.2512 16 17.6234 16 18.2V25.8C16 26.3766 16.0008 26.7488 16.0239 27.0322C16.0461 27.3038 16.0838 27.4045 16.109 27.454C16.2049 27.6422 16.3578 27.7951 16.546 27.891C16.5955 27.9162 16.6962 27.9539 16.9678 27.9761C17.2512 27.9992 17.6234 28 18.2 28H25.8C26.3766 28 26.7488 27.9992 27.0322 27.9761C27.3038 27.9539 27.4045 27.9162 27.454 27.891C27.6422 27.7951 27.7951 27.6422 27.891 27.454C27.9162 27.4045 27.9539 27.3038 27.9761 27.0322C27.9992 26.7488 28 26.3766 28 25.8V18.2C28 17.6234 27.9992 17.2512 27.9761 16.9678C27.9539 16.6962 27.9162 16.5955 27.891 16.546C27.7951 16.3578 27.6422 16.2049 27.454 16.109C27.4045 16.0838 27.3038 16.0461 27.0322 16.0239C26.7488 16.0008 26.3766 16 25.8 16H18.2C17.6234 16 17.2512 16.0008 16.9678 16.0239ZM26.7071 19.2929C27.0976 19.6834 27.0976 20.3166 26.7071 20.7071L22.0607 25.3536C21.4749 25.9393 20.5251 25.9393 19.9393 25.3536L17.2929 22.7071C16.9024 22.3166 16.9024 21.6834 17.2929 21.2929C17.6834 20.9024 18.3166 20.9024 18.7071 21.2929L21 23.5858L25.2929 19.2929C25.6834 18.9024 26.3166 18.9024 26.7071 19.2929Z"
                              fill="white"
                            />
                          </svg>
                        )}
                        {(field?.field_type === "Date" || field?.field_type === "Time") && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="45"
                            height="45"
                            viewBox="0 0 45 45"
                            fill="none"
                          >
                            <rect
                              x="0.6604"
                              y="0.116211"
                              width="44"
                              height="44"
                              rx="6"
                              fill="#0271BE"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M20.6104 14.1162C20.3788 12.9751 19.3699 12.1162 18.1604 12.1162C16.9455 12.1162 15.9331 12.9828 15.7074 14.1315C15.6233 14.1355 15.5426 14.1405 15.4654 14.1468C15.07 14.1791 14.6768 14.2504 14.2984 14.4432C13.7339 14.7308 13.275 15.1898 12.9874 15.7542C12.7946 16.1326 12.7233 16.5258 12.691 16.9212C12.6604 17.2958 12.6604 17.7505 12.6604 18.2777V27.9548C12.6604 28.4819 12.6604 28.9367 12.691 29.3112C12.7233 29.7066 12.7946 30.0998 12.9874 30.4782C13.275 31.0427 13.7339 31.5016 14.2984 31.7892C14.6768 31.982 15.07 32.0533 15.4654 32.0856C15.8399 32.1162 16.2947 32.1162 16.8218 32.1162H28.499C29.0261 32.1162 29.4809 32.1162 29.8554 32.0856C30.2508 32.0533 30.644 31.982 31.0224 31.7892C31.5869 31.5016 32.0458 31.0427 32.3334 30.4782C32.5262 30.0998 32.5975 29.7066 32.6298 29.3112C32.6604 28.9367 32.6604 28.4819 32.6604 27.9548V18.2776C32.6604 17.7505 32.6604 17.2957 32.6298 16.9212C32.5975 16.5258 32.5262 16.1326 32.3334 15.7542C32.0458 15.1898 31.5869 14.7308 31.0224 14.4432C30.644 14.2504 30.2508 14.1791 29.8554 14.1468C29.7782 14.1405 29.6975 14.1355 29.6134 14.1315C29.3877 12.9828 28.3753 12.1162 27.1604 12.1162C25.9509 12.1162 24.942 12.9751 24.7104 14.1162H20.6104ZM15.6282 16.1401C15.3566 16.1623 15.2559 16.2 15.2064 16.2252C15.0182 16.3211 14.8653 16.4741 14.7694 16.6622C14.7442 16.7117 14.7065 16.8124 14.6843 17.084C14.6612 17.3674 14.6604 17.7397 14.6604 18.3162V19.1162H30.6604V18.3162C30.6604 17.7397 30.6596 17.3674 30.6365 17.084C30.6143 16.8124 30.5766 16.7117 30.5514 16.6622C30.4555 16.4741 30.3026 16.3211 30.1144 16.2252C30.0649 16.2 29.9642 16.1623 29.6926 16.1401C29.4092 16.117 29.037 16.1162 28.4604 16.1162H16.8604C16.2838 16.1162 15.9116 16.117 15.6282 16.1401ZM30.6604 21.1162V27.9162C30.6604 28.4928 30.6596 28.865 30.6365 29.1484C30.6143 29.42 30.5766 29.5208 30.5514 29.5702C30.4555 29.7584 30.3026 29.9113 30.1144 30.0072C30.0649 30.0324 29.9642 30.0701 29.6926 30.0923C29.4092 30.1154 29.037 30.1162 28.4604 30.1162H16.8604C16.2838 30.1162 15.9116 30.1154 15.6282 30.0923C15.3566 30.0701 15.2559 30.0324 15.2064 30.0072C15.0182 29.9113 14.8653 29.7584 14.7694 29.5702C14.7442 29.5208 14.7065 29.42 14.6843 29.1484C14.6612 28.865 14.6604 28.4928 14.6604 27.9162V21.1162H30.6604Z"
                              fill="white"
                            />
                          </svg>
                        )}
                        {field?.field_type === "Select" && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="45"
                            height="45"
                            viewBox="0 0 45 45"
                            fill="none"
                          >
                            <rect
                              x="0.849609"
                              y="0.116211"
                              width="44"
                              height="44"
                              rx="6"
                              fill="#0271BE"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M22.8496 14.4191L16.4454 17.6424L22.8496 20.8658L29.2538 17.6424L22.8496 14.4191ZM22.1043 12.2933C22.5735 12.0572 23.1257 12.0572 23.5949 12.2933L31.2414 16.1419C32.4698 16.7601 32.4698 18.5247 31.2414 19.143L23.5949 22.9915C23.1257 23.2277 22.5735 23.2277 22.1043 22.9915L22.6012 21.9912L22.1043 22.9915L14.4578 19.143L14.9547 18.1426L14.4578 19.143C13.2294 18.5247 13.2294 16.7601 14.4578 16.1419L22.1043 12.2933ZM12.9672 21.616C13.2416 21.0635 13.909 20.8396 14.4578 21.1158L22.8496 25.3395L31.2414 21.1158C31.7902 20.8396 32.4576 21.0635 32.7321 21.616C33.0065 22.1685 32.784 22.8403 32.2352 23.1166L23.5949 27.4653C23.1257 27.7015 22.5735 27.7015 22.1043 27.4653L13.464 23.1166C12.9152 22.8403 12.6927 22.1685 12.9672 21.616ZM12.9672 26.0898C13.2416 25.5373 13.909 25.3134 14.4578 25.5896L22.8496 29.8133L31.2414 25.5896C31.7902 25.3134 32.4576 25.5373 32.7321 26.0898C33.0065 26.6423 32.784 27.3141 32.2352 27.5904L23.5949 31.9391C23.1257 32.1752 22.5735 32.1753 22.1043 31.9391L13.464 27.5904C12.9152 27.3141 12.6927 26.6423 12.9672 26.0898Z"
                              fill="white"
                            />
                          </svg>
                        )}
                        {field?.field_type !== "Boolean" && (
                          <div className="d-flex flex-column ms-2 ">
                            <label className="text-secondary d-flex justify-content-start">
                              {field?.field_name}
                            </label>
                            <div className="mt-1 w-100">
                              {renderField(field, index)}
                            </div>
                          </div>
                        )}
                        {field?.field_type === "Boolean" && (
                          <div className="d-flex col-10 ms-2 justify-content-between p-3 mb-1">
                            <div>
                              {" "}
                              <strong className="text-dark font-weight-bold">
                                {field?.field_name}
                              </strong>
                            </div>
                            {renderField(field, index)}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className=" mt-lg-0 mt-xxl-4 d-flex gap-2 align-items-center justify-content-end mt-2 ">
              {isView("isCheckOut") && (
                <button className=" btn btn-primary " style={{ fontSize: '20px !important' }} onClick={checkOut}>
                  {findDisplayName("ProfileScreenConfirmButton", "Confirm")}
                </button>
              )}
              <button
                className=" btn btn-secondary"
                onClick={() => cancelCheckout()}
              >
                {findDisplayName("ProfileScreenCancelButton", "Cancel")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
